module.exports = __webpack_public_path__ + "media/bootstrap-icons/record-btn-fill-09937ab5.svg";